import { useState } from "react";

export const useResourceAuditDialog = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [resourceId, setResourceId] = useState<string>("");
  const [resourceName, setResourceName] = useState<string>("");

  const openDialog = (id: string, name?: string) => {
    setResourceId(id);
    setResourceName(name || "");
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
    setResourceId("");
    setResourceName("");
  };

  return {
    isOpen,
    resourceId,
    resourceName,
    openDialog,
    closeDialog,
  };
};
